import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-application-form',
    templateUrl: './application-form.component.html',
    styleUrls: ['./application-form.component.scss'],
    standalone: false
})
export class ApplicationFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
